import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteAbout() {
  const site = useSiteContent();
  usePageMeta("About Us | Wales Event Medical Services",
    "Experienced, fully-vetted event medical teams based in Wales and covering the whole UK — working to CQC-equivalent standards of care and governance.", "", "about");
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-about">
      <SiteHeader />
      <SiteSections sections={site.page_sections.about} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
